import parleyHttpClient from './parleyHttpClient';
import type { AuthMeResponse } from '@/types/parley';

export async function fetchMe(): Promise<AuthMeResponse> {
  // No client-side timeout: /v1/auth/me resolves the caller's identity, role,
  // and account memberships, which can be slow on a cold backend (Moira / LDAP
  // / roles lookups). We wait for the API to answer rather than abort it — a
  // timeout here would silently degrade the session to a default 'user' role.
  // The 30s ceiling on parleyHttpClient still applies to every other endpoint.
  const { data } = await parleyHttpClient.get<AuthMeResponse>('/v1/auth/me', { timeout: 0 });
  return data;
}
